<template>
<div v-bar>
  <div>
  <p class="description padding" style="white-space: pre-wrap"  v-html="currentProject.project_description"></p>
  </div>
</div>
</template>

<script>
import '../../src/assets/css/leonie_scrollbar.css';

export default {
  name: 'ProjectDescription',
  props: ['currentProject'],
  data() {
    return {
      video: false
    }
  },
  methods: {
    show_video: function() {
      this.video = true;
    }
  }
}
</script>

<style scoped>
div {
  /* overflow-y:auto; */
  box-sizing: content-box;
	width:100%;
  height:100%;
	border-radius: 25px;
}

p {
  width:100%;
}
			
</style>